import useCommandFlowStore from "../../store/commandFlowStore";

/**
 * Utility functions for managing command state in the store
 */

/**
 * Store payload data for commands and steps
 * @param {Object} payload - The payload data to store
 */
export const storePayload = (payload) => {
  const setCurrentPayload = useCommandFlowStore.getState().setCurrentPayload;
  setCurrentPayload(payload);
};

/**
 * Get stored payload data
 * @returns {Object|null} The stored payload data
 */
export const getStoredPayload = () => {
  return useCommandFlowStore.getState().currentPayload;
};

/**
 * Store redirect data
 * @param {string} command - The target command
 * @param {Object} data - The data to pass to the command
 * @param {string} fromCommand - The originating command (optional)
 */
export const storeRedirectData = (command, data, fromCommand = null) => {
  const setCurrentRedirectData =
    useCommandFlowStore.getState().setCurrentRedirectData;
  setCurrentRedirectData({
    command,
    data,
    fromCommand,
  });
};

/**
 * Get stored redirect data
 * @returns {Object|null} The stored redirect data
 */
export const getStoredRedirectData = () => {
  return useCommandFlowStore.getState().currentRedirectData;
};

/**
 * Clear all command-related state
 * This is useful when exiting commands or starting fresh
 */
export const clearAllCommandState = () => {
  const clearCommandState = useCommandFlowStore.getState().clearCommandState;
  clearCommandState();
};

/**
 * Clear only redirect-related state
 */
export const clearRedirectState = () => {
  const setCurrentRedirectData =
    useCommandFlowStore.getState().setCurrentRedirectData;
  setCurrentRedirectData(null);
};

/**
 * Clear only payload
 */
export const clearPayload = () => {
  const setCurrentPayload = useCommandFlowStore.getState().setCurrentPayload;
  setCurrentPayload(null);
};

/**
 * Check if there's an active command session with stored state
 * @returns {boolean} True if there's active command state
 */
export const hasActiveCommandState = () => {
  const store = useCommandFlowStore.getState();
  return !!(
    store.inSession ||
    store.currentRedirectData ||
    store.currentPayload
  );
};

/**
 * Get a summary of current command state for debugging
 * @returns {Object} Summary of current state
 */
export const getCommandStateSummary = () => {
  const store = useCommandFlowStore.getState();
  return {
    inSession: store.inSession,
    hasRedirectData: !!store.currentRedirectData,
    hasPayload: !!store.currentPayload,
    currentPrompt: !!store.currentPrompt,
  };
};
